import { FC } from 'react';
import ReactModal from 'react-modal';
import { theme } from 'styles/theme';
import { Box, Btn } from './ModalAgree.styled';
import { PropsChildren } from '../../../../@types/modals.types';

const customStyles = {
  overlay: {
    zIndex: 5,
    backgroundColor: 'rgba(23, 26, 29, 0.75)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  content: {
    position: 'static' as const,
    inset: 'auto',
    border: 'none',
    borderRadius: theme.radii.card,
    padding: 0,
    background: theme.brand.surface,
    maxWidth: '92vw',
    maxHeight: '90vh',
    overflow: 'auto',
  },
};

ReactModal.setAppElement('#modal-root');

type Props = {
  isModalAgreeOpen: boolean;
  handleCloseAgreeModal: () => void;
  buttonText: string;
};

export const ModalAgree: FC<PropsChildren & Props> = ({
  children,
  isModalAgreeOpen,
  handleCloseAgreeModal,
  buttonText,
}) => {
  return (
    <ReactModal isOpen={isModalAgreeOpen} style={customStyles}>
      <Box>
        {children}
        <Btn type="button" onClick={handleCloseAgreeModal}>
          <div>{buttonText}</div>
        </Btn>
      </Box>
    </ReactModal>
  );
};
